import { useEffect, useState } from 'react';
import { getOwnSubjects } from '../../Subject/services/subjectService';
import { getAttendanceTrend, WEEK_RANGE } from '../services/attendanceTrendService';

// The signed-in teacher's daily attendance rate per section they handle, for the dashboard trend
// chart. `range` is 'week' (current Monday-Friday) or 'month' (current calendar month).
// `trend` stays null while loading or when it couldn't be loaded.
export function useAttendanceTrend(enabled, range = WEEK_RANGE) {
  const [trend, setTrend] = useState(null);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) return undefined;
    let mounted = true;
    setLoading(true);

    getOwnSubjects()
      .then((subjects) => getAttendanceTrend(subjects, range))
      .then((result) => {
        if (mounted) setTrend(result);
      })
      .catch(() => {
        // The chart falls back to its empty state; the rest of the dashboard still works.
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [enabled, range]);

  return { trend, loading };
}
